// node_modules
import { FC, useContext, useEffect, useState } from "react";
// Components
import { MarkdownItComponent, ProseMirrorEditor, FindestButton } from "Components";
// Controllers
import { ProseMirrorPluginControllerSingleton } from "Controllers";
// styles
import styles from "./saveableEditableMarkdown.module.scss";
// Contexts
import { WebsocketContext } from "Providers";
// Constants
import { HubConstants } from "Constants";

type TSaveableEditableMarkdownProps = {
    source: string,
    noSource?: string,
    isEditing: boolean,
    onSave: (text: string) => void,
    env?: any,
    resourceName: string,
    doLinkify?: boolean
};

export const SaveableEditableMarkdown: FC<TSaveableEditableMarkdownProps> = ({source, noSource, isEditing, onSave, env, 
        resourceName, doLinkify}: TSaveableEditableMarkdownProps) => {
    // State
    const [editableMarkdown, setEditableMarkdown] = useState<string>(source);

    // Contexts
    const { webSocketController } = useContext(WebsocketContext);

    // Logic
    useEffect(() => {
        setEditableMarkdown(source);
    }, [source]);

    const updateEditableMarkdown = (text: string) => {
        setEditableMarkdown(text);
    };

    const onSaveClick = () => {
        onSave(editableMarkdown);
    };

    const onStopClick = () => {
        setEditableMarkdown(source);

        // stop claiming editing on the current resource
        webSocketController.invokeFunction(HubConstants.STOP_EDITING_DELIVERY_RESOURCE, resourceName);
    };
    
    return (
        <>
        {isEditing ? 
            <div>
                <ProseMirrorEditor source={editableMarkdown} plugins={ProseMirrorPluginControllerSingleton.getDefault()} documentChanged={updateEditableMarkdown} extraClassNameWisiwygBottomContainer={styles.editingWisiwygBottomContainer} />
                <div className={styles.editingButtonContainer}>
                    <FindestButton extraClassName={styles.saveButton} title="Save" onClick={onSaveClick}/>
                    <FindestButton extraClassName={styles.cancelButton} title="Cancel" onClick={onStopClick}/>  
                </div>
            </div>
        : 
            <div>
                <MarkdownItComponent source={editableMarkdown} noSource={noSource} env={env} doLinkify={doLinkify}/>
            </div>
        }
    </>
    );
};